import { render } from "./TeaserItem.vue?vue&type=template&id=3709d8fe&scoped=true"
import script from "./TeaserItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TeaserItem.vue?vue&type=script&setup=true&lang=js"

import "./TeaserItem.vue?vue&type=style&index=0&id=3709d8fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3709d8fe"],['__file',"src/components/Ui/TeaserItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3709d8fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3709d8fe', __exports__)) {
    api.reload('3709d8fe', __exports__)
  }
  
  module.hot.accept("./TeaserItem.vue?vue&type=template&id=3709d8fe&scoped=true", () => {
    api.rerender('3709d8fe', render)
  })

}


export default __exports__